import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaSearch, FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const SearchComponent = ({closeSearchBar}) => {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [blogs, setBlogs] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;



    const staticPages = [
        {
            title: 'About Us', description: 'Learn more about our company and mission.',url: '/about',
        },
        {
            title: 'Contact Us',description: 'Get in touch with us for any queries or support.',url: '/contact',
        },
        {
            title: 'Home',description: 'Envisioning a Poverty-free Society',url: '/',
        },
        {
            title: 'Akhuwat Islamic Microfinance (AIM)',description: 'Microfinance refers to the provision of financial services to deserving and low-income individuals.',url: '/aim',
        },
        {
            title: 'Akhuwat Education Services (AES)',description: 'AES was initiated to provide quality education, free of cost to deserving students across Pakistan. ',url: '/aes',
        },
        {
            title: 'Akhuwat Khwajasira Program (AKSP)',description: 'The social and economic exclusion of the Khwajasira or transgender (Third Gender) community in Pakistan ',url: '/programs/aksp',
        },
        {
            title: 'Disaster Management',description: 'Akhuwat is committed to helping people out in times of crises; financial, medical, or natural disasters',url: '/programs/disaster',
        },
        {
            title: 'Community Development',description: 'Akhuwat implements a participatory development approach involving the local community to identify problems and design localized solutions for development',url: '/programs/community',
        },
        {
            title: 'Akhuwat Clothes Bank',description: 'Akhuwat Clothes Bank (ACB) caters to the underprivileged families across Pakistan through the dedicated collection, refurbishment, and distribution of clothes and household accessories as a gift. ',url: '/programs/acb',
        },
        {
            title: 'Akhuwat Loan Process',description: 'khuwat Islamic Microfinance (AIM) approves loans after following specific eligibility criteria, conducting social and business appraisals of potential beneficiaries, and enlisting guarantors for loan disbursement.',url: '/programs/loan/process',
        },
        {
            title: 'Akhuwat Loan Products',description: 'Family enterprise loans are offered by AIM for the establishment of a new business or the expansion of an existing one.',url: '/programs/loan/products',
        },
        {
            title: 'Donate ',description: 'Donate now for our programs',url: 'https://donate.akhuwat.org.pk/',
        },
        {
            title: 'Akhuwat Stories',description: 'Akhuwat top stories',url: '/programs/stories/hope',
        },
        {
            title: 'Our Timeline',description: 'Akhuwat Timeline Stories',url: '/about#timeline',
        },
        {
            title: 'Our Leadership',description: 'Our Leadership and International Chapters ',url: '/leader',
        },
        {
            title: 'Our Founder',description: 'Our Founder Page ',url: '/founder',
        },
        {
            title: 'Akhuwat Reports',description: 'All kind of Reports Financial,Yearly Reports,assesment reports ',url: '/reports',
        },
        {
            title: 'Media',description: 'Our Media page for showing all blogs,news,books and publications',url: '/media',
        },
        {
            title: 'Get Involved',description: 'Akhuwat needs your support and donations to alleviate poverty, educate deserving students, support Khwajasiras (transgender community), and provide relief measures during natural disasters.',url: '/involved',
        },
        {
            title: 'Akhuwat Books',description: 'Stories of Resilience And Rebuilding After the 2022 Floods',url: '/book',
        },
        {
            title: 'Mawakhat Book',description: 'Stories of Resilience And Rebuilding After the 2022 Floods',url: '/book',
        },
        {
            title: 'Branch Network',description: 'Visit an Akhuwat branch today',url: '/contact',
        },
        {
            title: 'Akhuwat GIS',description: 'Using our Geographic Information System (GIS), you can easily find the nearest Akhuwat branch to you.',url: '/contact',
        },
        {
            title: 'Bank Details',description: 'We accept donations in most major banks of Pakistan. Find out more on our banking details page',url: '/bank/details',
        },
    ];

    // Fetch blog data from API
    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/api/v1/all/users/blogs`);
                setBlogs(response.data?.data || []); // Adjust based on API response structure
            } catch (error) {
                console.error('Error fetching blogs:', error);
            }
        };

        fetchBlogs();
    }, []);

    // Handle search input
    const handleSearch = (e) => {
        const searchQuery = e.target.value.toLowerCase();
        setQuery(searchQuery);
        setCurrentPage(1); // Reset to first page on new search

        if (searchQuery.length > 0) {
            const filteredBlogs = blogs.filter(
                (blog) =>
                    blog.title.toLowerCase().includes(searchQuery) ||
                    blog.description.toLowerCase().includes(searchQuery)
            );

            const filteredPages = staticPages.filter(
                (page) =>
                    page.title.toLowerCase().includes(searchQuery) ||
                    page.description.toLowerCase().includes(searchQuery)
            );

            setResults([
                ...filteredBlogs.map((blog) => ({
                    type: 'blog',
                    title: blog.title,
                    description: blog.description,
                    url: `/blogs/${blog.id}`,
                })),
                ...filteredPages,
            ]);
        } else {
            setResults([]);
        }
    };

    // Handle clearing the search
    const clearSearch = () => {
        setQuery('');
        setResults([]);
    };

    // Pagination logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentResults = results.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(results.length / itemsPerPage);

    return (
        <div className="relative z-100 p-5 bg-MistyLilc w-full">



            {/* Search Input */}
            <div className="relative flex flex-row items-center bg-white border border-gray-300 rounded-full px-3 lg:py-2 py-3 shadow-sm mx-auto max-w-[400px]">
                <FaSearch className="text-gray-500 mr-2" />
                <input
                    type="text"
                    value={query}
                    onChange={handleSearch}
                    className="flex-1 bg-transparent outline-none text-gray-700"
                    placeholder="What can we help you find"
                />
         
                                {/* Header with Close Icon */}
                                <div className="flex  items-center mr-2  ">
                <button onClick={closeSearchBar} className="text-gray-500 hover:text-gray-700">
                    <FaTimes className="text-xl" />
                </button>
            </div>
            </div>

            {/* Search Results */}
            {currentResults.length > 0 && (
                <div
                    className="lg:absolute z-50 relative top-full mt-2 left-1/2 transform -translate-x-1/2 w-full max-w-[700px] bg-white border border-gray-200 shadow-lg rounded-lg overflow-hidden"
                >
                    <div className="bg-gray-100 px-4 py-2 border-b">
                        <p className="font-semibold text-gray-700">Search Results</p>
                    </div>
                    <div className="max-h-64 overflow-y-auto">
                        {currentResults.map((result, index) => (
                            <Link
                                key={index}
                                to={result.url}
                                className="block px-4 py-3 hover:bg-gray-200"
                            >
                                <div className="flex items-center justify-between">
                                    <div>
                                        <p className="font-semibold text-topGreen font-manrope">{result.title}</p>
                                        <p className="font-normal text-customBlack font-manrope">{result.description}</p>
                                    </div>
                                    <span className="text-customGreen font-manrope font-semibold ">&rarr;</span>
                                </div>
                            </Link>
                        ))}
                    </div>

                    {/* Pagination */}
                    {totalPages > 1 && (
                        <div className="flex justify-between items-center bg-gray-100 px-4 py-2 border-t">
                            <button
                                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                disabled={currentPage === 1}
                                className={`px-3 py-1 rounded ${
                                    currentPage === 1
                                        ? 'bg-gray-200 text-gray-400'
                                        : 'bg-customGreen text-white hover:bg-topGreen'
                                }`}
                            >
                                Previous
                            </button>
                            <span className="text-gray-700">
                                Page {currentPage} of {totalPages}
                            </span>
                            <button
                                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                                disabled={currentPage === totalPages}
                                className={`px-3 py-1 rounded ${
                                    currentPage === totalPages
                                        ? 'bg-gray-200 text-gray-400'
                                        : 'bg-customGreen text-white hover:bg-topGreen'
                                }`}
                            >
                                Next
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default SearchComponent;
